import request from '@/router/axios';

// export const getList = (current, size, params) => {
//   return request({
//     url: '/api/v4ward/notice/list',
//     method: 'get',
//     params: {
//       ...params,
//       current,
//       size,
//     }
//   })
// };
export const getList = (params, options) =>
  request.get('/api/v4ward/notice/list', Object.assign({}, options, { params }));

export const remove = (ids) => {
  return request({
    url: '/api/v4ward/notice/remove',
    method: 'post',
    params: {
      ids,
    }
  })
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/notice/submit',
    method: 'post',
    data: row
  })
};

export const update = (row) => {
  return request({
    url: '/api/v4ward/notice/submit',
    method: 'post',
    data: row
  })
};

export const getNotice = (id) => {
  return request({
    url: '/api/v4ward/notice/detail',
    method: 'get',
    params: {
      id
    }
  })
};

//最新通知
export const getNewestNotice = (tenantId) => {
  return request({
    url: '/api/v4ward/notice/newest',
    method: 'get',
    params: {
      tenantId
    }
  })
};

// //根据项目id查询通知公告并根据发布时间逆序和名称自然排序
//   export const getProjectNoticePage = (current, size, params) => {
//   return request({
//     url: '/api/v4ward/notice/project-page',
//     method: 'get',
//     params: {
//       ...params,
//       current,
//       size,
//     }
//   })
// };

export const getProjectNoticePage = (params, options) =>
  request.get('/api/v4ward/notice/project-page', Object.assign({}, options, { params }));

